/* Nexvo — comportamiento. Todo vanilla, sin librerías.
   Regla: si un elemento no existe, la función sale y no rompe nada. */
(function () {
  /* El mismo archivo se enlaza desde varias secciones: sin esta guarda el script
     se ejecutaría una vez por etiqueta y duplicaría observadores y barras. */
  if (window.__nxBooted) return;
  window.__nxBooted = true;
  document.documentElement.classList.add('nx-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- revelado al hacer scroll, con red de seguridad --- */
  function initReveal() {
    var els = document.querySelectorAll('.nx-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('nx-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        setTimeout(function () { e.target.classList.add('nx-visible'); }, Math.min(i, 5) * 70);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
    /* pase lo que pase, a los 2,5 s todo es visible */
    setTimeout(function () {
      document.querySelectorAll('.nx-reveal:not(.nx-visible)').forEach(function (e) { e.classList.add('nx-visible'); });
    }, 2500);
  }

  /* --- header que se condensa --- */
  function initSticky() {
    var sb = document.querySelector('[data-nx-sticky]');
    if (!sb) return;
    var t = false;
    function on() {
      if (t) return; t = true;
      requestAnimationFrame(function () { sb.classList.toggle('nx-cond', window.scrollY > 90); t = false; });
    }
    window.addEventListener('scroll', on, { passive: true }); on();
  }

  /* --- paralaje de puntero en el escenario del hero --- */
  function initStage() {
    var stage = document.querySelector('[data-nx-stage]');
    if (!stage || reduce || !window.matchMedia('(pointer:fine)').matches) return;
    var layers = stage.querySelectorAll('[data-nx-px]');
    stage.addEventListener('pointermove', function (ev) {
      var r = stage.getBoundingClientRect();
      var nx = (ev.clientX - r.left) / r.width - 0.5, ny = (ev.clientY - r.top) / r.height - 0.5;
      layers.forEach(function (l) {
        var p = parseFloat(l.getAttribute('data-nx-px')) || 0;
        l.style.transform = 'translate3d(' + (nx * p) + 'px,' + (ny * p) + 'px,0)';
      });
    });
    stage.addEventListener('pointerleave', function () {
      layers.forEach(function (l) { l.style.transform = ''; });
    });
  }

  /* --- ciclo del pedido: confirmado -> en camino -> revisado -> pagado --- */
  function initOrder() {
    var steps = document.querySelectorAll('.nx-oc-track li');
    var pay = document.querySelector('.nx-oc-pay');
    if (steps.length !== 3 || !pay) return;
    if (reduce) {
      steps.forEach(function (s) { s.classList.add('nx-lit'); });
      steps[2].classList.add('nx-done'); pay.classList.add('nx-paid');
      return;
    }
    function run() {
      steps.forEach(function (s) { s.classList.remove('nx-lit', 'nx-done'); });
      pay.classList.remove('nx-paid');
      setTimeout(function () { steps[0].classList.add('nx-lit'); }, 800);
      setTimeout(function () { steps[1].classList.add('nx-lit'); }, 3200);
      setTimeout(function () { steps[2].classList.add('nx-lit', 'nx-done'); }, 5600);
      setTimeout(function () { pay.classList.add('nx-paid'); }, 6400);
      setTimeout(run, 15000);
    }
    run();
  }

  /* --- comparador antes / después --- */
  function initBA() {
    var ba = document.querySelector('[data-nx-ba]');
    if (!ba) return;
    var drag = false;
    function set(ev) {
      var r = ba.getBoundingClientRect();
      var p = Math.max(14, Math.min(94, ((ev.clientX - r.left) / r.width) * 100));
      ba.style.setProperty('--nx-x', p + '%');
    }
    ba.addEventListener('pointerdown', function (ev) {
      ba.classList.remove('nx-auto'); drag = true; set(ev);
      if (ba.setPointerCapture) { try { ba.setPointerCapture(ev.pointerId); } catch (e) {} }
    });
    ba.addEventListener('pointermove', function (ev) { if (drag) set(ev); });
    window.addEventListener('pointerup', function () { drag = false; });
    if (!reduce) ba.classList.add('nx-auto');
  }

  /* --- la conversación se escribe sola --- */
  function initChat() {
    var chat = document.querySelector('[data-nx-chat]');
    if (!chat) return;
    var msgs = [].slice.call(chat.querySelectorAll('.nx-msg'));
    var typ = chat.querySelector('.nx-typing');
    if (reduce || !('IntersectionObserver' in window)) {
      msgs.forEach(function (m) { m.classList.add('nx-in'); });
      return;
    }
    new IntersectionObserver(function (es, ob) {
      if (!es[0].isIntersecting) return;
      ob.disconnect();
      var t = 500;
      msgs.forEach(function (m) {
        var mine = m.classList.contains('nx-me');
        if (!mine && typ) { setTimeout(function () { typ.classList.add('nx-on'); chat.appendChild(typ); }, t); t += 900; }
        setTimeout(function () { if (typ) typ.classList.remove('nx-on'); m.classList.add('nx-in'); }, t);
        t += mine ? 700 : 600;
      });
      setTimeout(function () { if (typ) typ.remove(); }, t + 400);
    }, { threshold: 0.35 }).observe(chat);
  }

  /* --- barra de compra fija: entra cuando el botón principal se va --- */
  function initStick() {
    var stick = document.querySelector('[data-nx-stick]');
    var anchor = document.querySelector('[data-nx-mainbuy]');
    if (!stick || !anchor || !('IntersectionObserver' in window)) { if (stick) stick.classList.add('nx-on'); return; }
    new IntersectionObserver(function (es) {
      stick.classList.toggle('nx-on', !es[0].isIntersecting);
    }, { threshold: 0 }).observe(anchor);
  }

  /* --- galería de la ficha --- */
  function initGal() {
    var gal = document.querySelector('[data-nx-gal]');
    if (!gal) return;
    var main = gal.querySelector('[data-nx-galmain]');
    if (!main) return;
    gal.querySelectorAll('[data-nx-galthumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src'); if (!src) return;
        main.src = src;
        gal.querySelectorAll('[data-nx-galthumb]').forEach(function (o) { o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
      });
    });
  }


  /* --- la conversación del hero se escribe sola, en bucle --- */
  function initWa() {
    var wa = document.querySelector('[data-nx-wa]');
    if (!wa) return;
    var msgs = [].slice.call(wa.querySelectorAll('.nx-wa-b'));
    var typ = wa.querySelector('.nx-wa-typing');
    if (!msgs.length) return;
    if (reduce) { msgs.forEach(function (m) { m.classList.add('nx-in'); }); return; }
    var timers = [];
    function run() {
      timers.forEach(clearTimeout); timers = [];
      msgs.forEach(function (m) { m.classList.remove('nx-in'); });
      if (typ) typ.classList.remove('nx-on');
      var t = 700;
      msgs.forEach(function (m, i) {
        var mine = m.classList.contains('nx-me');
        if (!mine && typ) {
          timers.push(setTimeout(function () { typ.classList.add('nx-on'); m.parentNode.insertBefore(typ, m); }, t));
          t += 1100;
        }
        timers.push(setTimeout(function () { if (typ) typ.classList.remove('nx-on'); m.classList.add('nx-in'); }, t));
        t += mine ? 850 : 750;
      });
      timers.push(setTimeout(run, t + 5200));
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) run(); }, { threshold: .3 }).observe(wa);
    } else { run(); }
  }

  /* --- las cifras entran escalonadas ---
     Antes contaban desde cero. Se quitó: si la pestaña iba lenta, la cifra se
     quedaba en 0 y la web llegaba a decir «0 días de garantía». Un adorno no
     puede alterar un dato que el cliente usa para decidir. */
  function initCount() {
    var els = document.querySelectorAll('.nx-cifra');
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    els.forEach(function (e) { e.style.opacity = '0'; e.style.transform = 'translateY(12px)'; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        setTimeout(function () {
          e.target.style.transition = 'opacity .55s var(--nx-ease), transform .55s var(--nx-ease)';
          e.target.style.opacity = '1'; e.target.style.transform = 'none';
        }, i * 90);
      });
    }, { threshold: .4 });
    els.forEach(function (e) { io.observe(e); });
    /* red de seguridad: pase lo que pase, siempre visibles */
    setTimeout(function () {
      els.forEach(function (e) { e.style.opacity = '1'; e.style.transform = 'none'; });
    }, 2600);
  }

  /* --- resplandor que sigue al puntero en las secciones negras --- */
  function initGlow() {
    if (reduce || !window.matchMedia('(pointer:fine)').matches) return;
    document.querySelectorAll('.nx-section.nx-night').forEach(function (sec) {
      sec.addEventListener('pointermove', function (ev) {
        var r = sec.getBoundingClientRect();
        sec.style.setProperty('--nx-mx', (ev.clientX - r.left) + 'px');
        sec.style.setProperty('--nx-my', (ev.clientY - r.top) + 'px');
        sec.classList.add('nx-glow');
      });
      sec.addEventListener('pointerleave', function () { sec.classList.remove('nx-glow'); });
    });
  }


  /* --- barra de lectura --- */
  function initProgress() {
    if (reduce) return;
    var bar = document.createElement('div');
    bar.className = 'nx-progress';
    document.body.appendChild(bar);
    var t = false;
    addEventListener('scroll', function () {
      if (t) return; t = true;
      requestAnimationFrame(function () {
        var h = document.documentElement.scrollHeight - innerHeight;
        bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(scrollY / h, 1) : 0) + ')';
        t = false;
      });
    }, { passive: true });
  }

  /* --- paralaje suave en las fotos grandes --- */
  function initParallax() {
    if (reduce) return;
    var imgs = [].slice.call(document.querySelectorAll('.nx-dest-img img, .nx-ben .nx-pic img'));
    if (!imgs.length) return;
    imgs.forEach(function (i) { i.classList.add('nx-parallax'); });
    var t = false;
    function upd() {
      if (t) return; t = true;
      requestAnimationFrame(function () {
        imgs.forEach(function (img) {
          var r = img.parentNode.getBoundingClientRect();
          if (r.bottom < -200 || r.top > innerHeight + 200) return;
          var k = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
          img.style.transform = 'scale(1.10) translateY(' + (k * -16).toFixed(2) + 'px)';
        });
        t = false;
      });
    }
    addEventListener('scroll', upd, { passive: true }); upd();
  }

  /* --- las tarjetas se inclinan hacia el puntero --- */
  function initTilt() {
    if (reduce || !matchMedia('(pointer:fine)').matches) return;
    document.querySelectorAll('.nx-tcard, .nx-step, .nx-pcard').forEach(function (c) {
      c.classList.add('nx-tilt');
      c.addEventListener('pointermove', function (ev) {
        var r = c.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - .5, y = (ev.clientY - r.top) / r.height - .5;
        c.classList.add('nx-tilt-on');
        c.style.transform = 'perspective(900px) rotateX(' + (-y * 3.2).toFixed(2) + 'deg) rotateY(' + (x * 3.2).toFixed(2) + 'deg) translateY(-5px)';
      });
      c.addEventListener('pointerleave', function () {
        c.classList.remove('nx-tilt-on'); c.style.transform = '';
      });
    });
  }

  /* --- las promesas de la banda entran escalonadas --- */
  function initPromesa() {
    var prs = document.querySelectorAll('.nx-pr');
    if (!prs.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      prs.forEach(function (p) { p.classList.add('nx-visible'); }); return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        setTimeout(function () { e.target.classList.add('nx-visible'); }, i * 110);
        io.unobserve(e.target);
      });
    }, { threshold: .3 });
    prs.forEach(function (p) { io.observe(p); });
    setTimeout(function () {
      document.querySelectorAll('.nx-pr:not(.nx-visible)').forEach(function (p) { p.classList.add('nx-visible'); });
    }, 2500);
  }


  /* --- la luz sigue al puntero dentro de cada tarjeta --- */
  function initLuz() {
    if (reduce || !matchMedia('(pointer:fine)').matches) return;
    document.querySelectorAll('.nx-card,.nx-tcard,.nx-step,.nx-pcard,.nx-ben').forEach(function (c) {
      c.addEventListener('pointermove', function (ev) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--nx-cx', (ev.clientX - r.left) + 'px');
        c.style.setProperty('--nx-cy', (ev.clientY - r.top) + 'px');
      });
    });
  }

  /* --- la línea que conecta los pasos se llena al bajar --- */
  function initRail() {
    var wrap = document.querySelector('[data-nx-steps]');
    if (!wrap) return;
    var rail = document.createElement('span');
    rail.className = 'nx-steps-rail';
    rail.innerHTML = '<i></i>';
    wrap.prepend(rail);
    var fill = rail.querySelector('i');
    if (reduce) { fill.style.width = '100%'; return; }
    var t = false;
    function upd() {
      if (t) return; t = true;
      requestAnimationFrame(function () {
        var r = wrap.getBoundingClientRect();
        var k = (innerHeight * 0.82 - r.top) / Math.max(r.height * 0.7, 1);
        fill.style.width = Math.max(0, Math.min(1, k)) * 100 + '%';
        t = false;
      });
    }
    addEventListener('scroll', upd, { passive: true }); upd();
    setTimeout(function () { if (!parseFloat(fill.style.width)) fill.style.width = '100%'; }, 3000);
  }

  /* --- quitar el esqueleto cuando la imagen ya cargó --- */
  function initSkel() {
    document.querySelectorAll('.nx-dest-img,.nx-ben .nx-pic,.nx-pcard .nx-thumb,.nx-gal .nx-main').forEach(function (box) {
      var img = box.querySelector('img');
      if (!img) { box.classList.add('nx-lista'); return; }
      if (img.complete && img.naturalWidth) { box.classList.add('nx-lista'); return; }
      img.addEventListener('load', function () { box.classList.add('nx-lista'); });
      img.addEventListener('error', function () { box.classList.add('nx-lista'); });
      setTimeout(function () { box.classList.add('nx-lista'); }, 5000);
    });
  }

  /* --- paralaje suave en la foto del hero --- */
  function initHeroPar() {
    var img = document.querySelector('.nx-hero--foto .nx-heroimg');
    if (!img || reduce) return;
    var t = false;
    addEventListener('scroll', function () {
      if (t) return; t = true;
      requestAnimationFrame(function () {
        var y = Math.min(scrollY, 900);
        img.style.transform = 'scale(1.06) translateY(' + (y * 0.06).toFixed(1) + 'px)';
        t = false;
      });
    }, { passive: true });
  }

  /* --- vídeo del hero ---------------------------------------------------
     El póster es lo que se ve por defecto. El vídeo sólo se revela cuando
     de verdad está pintando fotogramas, así que un autoplay rechazado,
     el ahorro de datos o el movimiento reducido no dejan un hueco negro. */
  function initHeroVid() {
    var v = document.querySelector('.nx-hero--video video');
    if (!v) return;

    var con = navigator.connection || {};
    if (reduce || con.saveData === true || /2g/.test(con.effectiveType || '')) {
      v.removeAttribute('autoplay');
      v.parentNode.removeChild(v);
      return;
    }

    function mostrar() { v.classList.add('nx-on'); }
    function arranca() {
      var q = v.play();
      if (q && q.catch) q.catch(function () { /* sin autoplay se queda el póster */ });
    }
    if (v.readyState >= 3) mostrar();
    v.addEventListener('playing', mostrar);
    v.addEventListener('canplay', function () { if (v.paused) arranca(); });
    v.addEventListener('loadeddata', function () { if (v.currentTime > 0) mostrar(); });

    /* Los .mp4 del tema llegan como application/mp4 y el navegador se planta
       sin dar error. Se baja el archivo una vez y se re-etiqueta en memoria;
       la caché del CDN hace que la segunda visita no vuelva a pagarlo. */
    var suelto = v.getAttribute('data-nx-desk');
    if (suelto) {
      var url = innerWidth < 768 ? (v.getAttribute('data-nx-mov') || suelto) : suelto;
      fetch(url, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw 0; return r.blob(); })
        .then(function (b) {
          v.src = URL.createObjectURL(b.type === 'video/mp4' ? b : new Blob([b], { type: 'video/mp4' }));
          arranca();
        })
        .catch(function () { /* se queda el póster */ });
    } else {
      arranca();
    }

    /* fuera de pantalla no tiene sentido gastar batería descodificando */
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { if (v.src) { var q = v.play(); if (q && q.catch) q.catch(function () {}); } }
        else v.pause();
      });
    }, { threshold: 0.01 }).observe(v);
  }

  function boot() {
    initReveal(); initSticky(); initStage(); initOrder();
    initBA(); initChat(); initStick(); initGal();
    initWa(); initCount();
    initProgress(); initParallax(); initPromesa();
    initRail(); initSkel(); initHeroPar(); initHeroVid();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
